import {
  axios, IEndMeetingRequest, IMeetingDeleteDto, IMeetingDto, IMeetingToDto, meetings, TCalendarType,
} from '@utils';
import { AxiosResponse } from 'axios';
import { Service } from 'typedi';
import { ShowNotification } from '../ShowNotification';

@Service()
export class MeetingRequest {
  @ShowNotification()
  getMeeting(meetingId: number, calendarType: TCalendarType): Promise<AxiosResponse<IMeetingDto>> {
    return axios.get(`${meetings}${meetingId}?type=${calendarType}`);
  }

  @ShowNotification()
  acceptTimeOffer(id: number) {
    return axios.get(`user/answer/offer/accept?id=${id}`);
  }

  @ShowNotification()
  cancelTimeOffer(id: number) {
    return axios.get(`user/answer/offer/cancel?id=${id}`);
  }

  @ShowNotification('Встреча добавлена', 'success')
  createMeeting(data: IMeetingToDto): Promise<AxiosResponse<{ meetingId: number; }>> {
    return axios.post(`${meetings}meeting`, data);
  }

  @ShowNotification('Встреча удалена', 'warning')
  deleteMeeting(meetingId: number) {
    return axios.delete(`${meetings}${meetingId}`);
  }

  @ShowNotification('Встреча удалена', 'warning')
  deleteRecurringMeeting(data: IMeetingDeleteDto) {
    return axios.delete(`${meetings}`, { data });
  }

  @ShowNotification('Встреча обновлена')
  updateMeeting(data: IMeetingToDto): Promise<AxiosResponse<IMeetingDto>> {
    return axios.put(`${meetings}meeting`, data);
  }

  @ShowNotification('Встреча завершена')
  endMeeting(data: IEndMeetingRequest) {
    return axios.post('/meetings/end', data);
  }
}
